import React from "react";
import {Svg, Path} from "react-primitives-svg";
import PropTypes from "prop-types";
import {Colors} from "./HSL_COLORS";
import {svgSize} from "../helpers/svg";

export default function Icon({fill, height, width, ...rest}) {
  return (
    <Svg
      {...rest}
      {...svgSize(height, width)}
      viewBox="0 0 60 50"
      preserveAspectRatio="xMidYMid meet">
      <Path
        fill={fill.outer || fill}
        d="M33.8704648,47.750911 C31.7015915,49.925911 28.1852535,49.925911 26.0163803,47.750911 C23.8477183,45.575911 23.8477183,42.0496398 26.0163803,39.8746398 C28.1852535,37.6998517 31.7015915,37.6998517 33.8704648,39.8746398 C36.039338,42.0496398 36.039338,45.575911 33.8704648,47.750911"
        id="Fill-1"
      />
      <Path
        fill={fill.outer || fill}
        d="M21.4610704,22.8783686 C17.621493,24.1542161 14.0126197,26.3145975 10.9629718,29.3728602 L16.1988169,34.6239195 C18.0332535,32.7843008 20.1474085,31.3940466 22.4039577,30.4451059 L21.4610704,22.8783686 Z"
        id="Fill-3"
      />
      <Path
        fill={fill.outer || fill}
        d="M38.6482183,22.9501483 L37.702162,30.5404025 C39.8761056,31.486589 41.9133592,32.8442161 43.688007,34.624089 L48.9240634,29.3728178 C45.9329366,26.3734534 42.4049789,24.2351059 38.6482183,22.9501483"
        id="Fill-5"
      />
      <Path
        fill={fill.outer || fill}
        d="M19.5115775,7.23432203 C12.1911549,9.08580508 5.47707042,12.8866525 -4.22535211e-05,18.3792373 L5.23580282,23.6305085 C9.53023944,19.3237288 14.7487606,16.2858051 20.4396761,14.6819915 L19.5115775,7.23432203 Z"
        id="Fill-7"
      />
      <Path
        fill={fill.outer || fill}
        d="M40.5989366,7.29618644 L39.670838,14.7440678 C45.2749225,16.3639831 50.4127394,19.3798729 54.6509789,23.6305085 L59.8868239,18.3794492 C54.4659085,12.9427966 47.8318944,9.1684322 40.5989366,7.29618644"
        id="Fill-10"
      />
      <Path
        fill={fill.inner || fill}
        d="M29.9432324,37.5940466 C33.4141479,37.5940466 35.9827394,40.1696822 35.9827394,43.5116314 L35.9827394,43.6506144 C35.9827394,46.9921398 33.4141479,49.5681992 29.9432324,49.5681992 C26.4723169,49.5681992 23.9039366,46.9921398 23.9039366,43.6506144 L23.9039366,43.5116314 C23.9039366,40.1696822 26.4723169,37.5940466 29.9432324,37.5940466 Z M23.7651338,3.76205508 C23.5568239,1.74341102 24.6674577,0.212055085 26.5418239,0.212055085 L33.3448521,0.212055085 C35.2192183,0.212055085 36.3298521,1.74341102 36.1215423,3.76205508 L33.1365423,29.9366314 C32.9280211,31.8162924 31.6787958,32.9995551 29.9432324,32.9995551 C28.2078803,32.9995551 26.9582324,31.8162924 26.7501338,29.9366314 L23.7651338,3.76205508 Z"
        id="Fill-12"
      />
    </Svg>
  );
}

Icon.propTypes = {
  fill: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      inner: PropTypes.string,
      outer: PropTypes.string,
    }),
  ]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
Icon.defaultProps = {
  fill: {
    inner: Colors.secondary.hslMagenta,
    outer: Colors.primary.hslGrey,
  },
};
Icon.displayName = "Icons.NoConnection";
